import {
  NOTIFICATIONS_ADD,
  NOTIFICATIONS_DELETE,
  NOTIFICATIONS_DELETE_ALL,
  NOTIFICATIONS_HIDE,
  NOTIFICATIONS_REMOVE,
  NOTIFICATIONS_SEND,
  NOTIFICATIONS_SEND_TOAST,
  NOTIFICATIONS_SET,
  NOTIFICATIONS_SET_EMPTY,
  NOTIFICATIONS_SET_MESSAGE,
  NOTIFICATIONS_SET_TOTAL,
  NOTIFICATIONS_UPDATE,
} from './types';

export const actions = {
  [NOTIFICATIONS_SEND_TOAST]: ({ commit }, payload) => {
    const message = typeof payload === 'string' ? { message: payload } : payload;
    commit(NOTIFICATIONS_SET_MESSAGE, message);
  },
  [NOTIFICATIONS_SEND]: ({ commit }, payload) => {
    const message = typeof payload === 'string' ? { message: payload } : payload;
    commit(NOTIFICATIONS_SET_MESSAGE, message);
    commit(NOTIFICATIONS_ADD, message);
    commit(NOTIFICATIONS_SET_TOTAL, 1);
  },
  [NOTIFICATIONS_DELETE]: ({ commit }, payload) => {
    commit(NOTIFICATIONS_REMOVE, payload);
    commit(NOTIFICATIONS_SET_TOTAL, -1);
  },
  [NOTIFICATIONS_UPDATE]: ({ commit }, payload) => {
    commit(NOTIFICATIONS_SET, payload);
    commit(NOTIFICATIONS_SET_TOTAL, payload.length);
  },
  [NOTIFICATIONS_HIDE]: ({ commit }) => {
    commit(NOTIFICATIONS_SET_MESSAGE, {
      icon: '',
      message: '',
      timeout: 10000,
      title: '',
      type: 'info',
      data: undefined,
    });
  },
  [NOTIFICATIONS_DELETE_ALL]: ({ commit, state }) => {
    commit(NOTIFICATIONS_SET_EMPTY);
    commit(NOTIFICATIONS_SET_TOTAL, -state.notificationsTotal);
  },
};
